import {
  validateDmhAnswers,
  getFormattedTimestamp,
  debounceInput,
  isAustralianApiUrl
} from "../utils/helpers";

export default {
  methods: {
    validateDmhAnswers,
    getFormattedTimestamp,
    debounceInput,
    isAustralianApiUrl
  }
};
